import {Injectable} from "@angular/core";
import {Apollo} from "apollo-angular";
import {DeviceGqlModel, DeviceInputGqlModel} from "./device.gql-model";
import {HttpClient} from "@angular/common/http";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Injectable()
export class DeviceService {
  private url: string = "/api/devices";

  constructor(private http: HttpClient, private apollo: Apollo) {}

  async getDevicesByProjectId(
    page = DEFAULT_PAGE,
    limit = DEFAULT_PAGE_LIMIT,
    search: string,
    projectId: string,
    siteSummaryId: string,
  ): Promise<any> {
    if (!projectId) return {rows: [], count: 0};

    const params = {
      ...page && {page: `${page}`},
      ...limit && {limit: `${limit}`},
      ...search && {search},
      projectId,
      siteSummaryId,
      sequence: "true",
    };

    return await this.http.get(`${this.url}`, {params})
      .map((json: any) => ({rows: json.rows, count: +json.count}))
      .toPromise();
  }

  async listDevicesForProject(projectId: string, typeId: number = undefined): Promise<DeviceGqlModel[]> {
    const query = DeviceGqlModel.query;
    const variables = DeviceGqlModel.variables(projectId, typeId);

    return this.apollo.query({query, variables, fetchPolicy: "no-cache"})
      .pipe(DeviceGqlModel.mapper)
      .toPromise();
  }

  async updateDevicesForProject(projectId: string, devices: any[]): Promise<DeviceGqlModel[]> {
    const model = new DeviceInputGqlModel({projectId, devices});

    return this.apollo.mutate({mutation: model.mutation, variables: model.variables, fetchPolicy: "no-cache"})
      .pipe(DeviceInputGqlModel.mapper)
      .toPromise();
  }
}
